import { IWizardStep } from "../../../../wizard/types";
import innerValidator from "../../validators/step2/validator";
import Content from "../../create/step2/Content";

export const editConfigStep2: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Edit course",
  },
  content: Content,
  validator: innerValidator,
  stepName: "step2",
};
